import { createStore } from 'vuex'
import events from './modules/events'
import auth from './modules/auth'
import donations from './modules/donations'
import cart from './modules/cart'
import orders from './modules/orders'

export default createStore({
  state: {
    notification: null
  },
  mutations: {
    SET_NOTIFICATION(state, notification) {
      state.notification = notification
    },
    CLEAR_NOTIFICATION(state) {
      state.notification = null
    }
  },
  modules: {
    events,
    auth,
    donations,
    cart,
    orders
  }
}) 